import { render, staticRenderFns } from "./desktopElementTable.vue?vue&type=template&id=e7c4766c"
import script from "./desktopElementTable.vue?vue&type=script&lang=js"
export * from "./desktopElementTable.vue?vue&type=script&lang=js"
import style0 from "./desktopElementTable.vue?vue&type=style&index=0&id=e7c4766c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports